import styled from 'styled-components'
import {
  RefreshCw, XCircle, CheckCircle, ThumbsUp, ThumbsDown, Percent, DollarSign,
} from 'react-feather'
import { ButtonMui } from 'src/components/ButtonMui'
import theme from 'src/styles/theme'
import { Tooltip } from '@mui/material'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.8rem;
`

export const RefreshButton = styled(RefreshCw)`
    cursor: pointer;
    color: blue;
`

export const TrueIcon = styled(CheckCircle)`
    color: green;
`

export const FalseIcon = styled(XCircle)`
    color: red;
`

export const PercentIcon = styled(Percent)`
    color: white;
    width: 20px;
`

export const MoneyIcon = styled(DollarSign)`
    color: white;
    width: 20px;
`

export const ApprovedIcon = styled(ThumbsUp)`
    cursor: pointer;
    color: green;
`

export const RejectedIcon = styled(ThumbsDown)`
    cursor: pointer;
    color: red;
`

export const ApprovedIconDisabled = styled(ThumbsUp)`
    color: black;
`

export const RejectedIconDisabled = styled(ThumbsDown)`
    color: black;
`

export const Options = styled.div`
    display: flex;
    gap: 1rem;
`

export const ContainerButton = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 14rem !important;    
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomButtonRefresh = styled(ButtonMui)`
    width: 2rem !important;    
    margin: 0 !important;
`

export const TableMuiLabel = styled.div<{ backgroundColor?: string }>`
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : theme.colors.blue)};
  width: 100%;
  color: ${theme.colors.white};
  font-weight: bold;
  padding: 16px;
  font-size: 14px;
  display: flex;
`

export const CustomLabel = styled.div`
    width: 370px;
`

export const CustomLabelBetween = styled.div`
    width: 3px;
`

export const CustomLabelCount = styled.div`
    width: 140px;
`

export const ContainerProgress = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
`

export const ContainerProductsError = styled.div`
    display: flex;
    flex-direction: column;
`

export const InventoryInfo = styled.div`
    display: flex;
    gap: 1.5rem;
`
export const CellTolltip = styled(Tooltip)`
  cursor: pointer;
`
